"use client";

import { Button } from "@fanduel/formation-react-components";
import Image from "next/image";
import { PROMO_HUB_CARD_CLICKED } from "@/constants/amplitude";
import { FALLBACK_IMAGE } from "@/constants/media";
import { PROMOTIONS_FALLBACK_URL } from "@/constants/promotions";
import { Promotion } from "@/graphql/gql/graphql";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import styles from "./promotionsWidget.module.scss";
interface PromoProps {
  promo: Promotion;
  articleName?: string;
  sport?: string;
}

export default function PromotionDisplay({
  promo,
  sport,
  articleName,
}: PromoProps) {
  const { logAmplitudeEvent } = useAmplitude();
  const handleClick = (
    linkText: string,
    linkType: string,
    url: string,
    promo: Promotion
  ) => {
    logAmplitudeEvent(PROMO_HUB_CARD_CLICKED, {
      Module: "featured_promos",
      "Link Text": linkText,
      "Link Type": linkType,
      "Link URL": url,
      "Promo ID": promo.promoCode ?? "unknown",
      "Promo Name": promo.title ?? "unknown",
      "Article Name": articleName ?? "unknown",
      Sport: sport ?? "unknown",
    });
  };
  return (
    <div className={styles.promotion}>
      <Image
        src={promo.image ?? FALLBACK_IMAGE}
        width={300}
        height={150}
        alt={promo.title ?? "Promotion image"}
        sizes="(max-width: 960px) 100vw, 300px"
      />
      <div className={styles.buttons}>
        <a
          href={promo.detailsUrl ?? PROMOTIONS_FALLBACK_URL}
          target="_blank"
          rel="noreferrer"
        >
          <Button
            label="More Info"
            variant="tertiary"
            fill
            onClick={() => {
              handleClick(
                "More Info",
                "secondary",
                promo.detailsUrl ?? PROMOTIONS_FALLBACK_URL,
                promo
              );
            }}
          />
        </a>
        <a
          href={promo.ctaUrl ?? PROMOTIONS_FALLBACK_URL}
          target="_blank"
          rel="noreferrer"
        >
          <Button
            label={promo.ctaText ?? "Learn More"}
            variant="primary"
            fill
            onClick={() => {
              handleClick(
                promo.ctaText ?? "Learn More",
                "primary",
                promo.ctaUrl ?? PROMOTIONS_FALLBACK_URL,
                promo
              );
            }}
          />
        </a>
      </div>
    </div>
  );
}
